import { Component, inject, input, OnInit } from '@angular/core';
import { environmenProgress } from '../../../environments/environment.progress';
import { ILevelRating, IRating, ProgressPlayerService } from './progress-player.service';
import * as _ from "lodash";
import { TranslatePipe } from '@ngx-translate/core';
import { PlayersService } from '../../shared/services/players/players';


@Component({
  selector: 'app-progress-player',
  imports: [TranslatePipe],
  templateUrl: './progress-player.html',
  styleUrl: './progress-player.scss'
})

export class ProgressPlayer {
  levelCard = input<any>();
  readNow = input<boolean>(false);
  points = input<number>(0);
  maxPoints = input<number>(0);

  setProgress = environmenProgress;
  progressService = inject(ProgressPlayerService);
  // players = inject(PlayersService);
  // private player: any;

  // TODO поки для однієї картки
  playerProgress(level: any): string{
    let resultTxt = "txtEmpty";
    if(!_.isEmpty(this.progressService.showLevel)){
      this.initData();
      if(parseInt(level) !== 1000){    
      if(this.progressService.rating && this.progressService.showLevel.includes(parseInt(level))){
        let sRes: any = this.progressService.fnFindLevel(parseInt(level));
        if(sRes){
          let res: number = (sRes.points / sRes.maxPoints) * 100;
          let interest = parseFloat(res.toFixed(2));
          resultTxt = this.yourTxtRating(interest);
        }
      }
      }else{
        if(this.progressService.rating){
          resultTxt = this.allRatings(this.progressService.rating)
        }
      }
    }

    return resultTxt;
  }

  playerProgressOnline(level: any): string{
    let resultTxt = "txtEmpty";
    resultTxt = this.allRatingsReal();
    return resultTxt;
  }

  allRatings(rating: IRating): string {
    let resP = 0;
    let resMP = 0;
    rating.levels.forEach((item: ILevelRating)=>{
      if(this.progressService.showLevel.includes(item.level)){
        resP = resP + item.points;
        resMP = resMP + item.maxPoints;
      }
    });
    let res: number = (resP / resMP) * 100;
    let interest = parseFloat(res.toFixed(2));
    return this.yourTxtRating(interest);
  }

  allRatingsReal():string{
    let res: number = (this.points() / this.maxPoints()) * 100;
    let interest = parseFloat(res.toFixed(2));
    return this.yourTxtRating(interest);
  }

  private initData(){
    let InfoRQ = JSON.parse(sessionStorage.getItem("QuestInfo") as string);
    const typeIds = _.keys(InfoRQ?.cards_by_difficulty);
    if(typeIds.length > 0){
      this.progressService.fnFindType(parseInt(typeIds[0]));
    }
  }

  // private findPlayer(playerId:number){
  //   this.player = this.players.players.find((pl:any)=> pl.player_id === playerId);
  // }

  yourTxtRating(interest: number){
    let txt = 'txtEmpty';

    this.setProgress.ratings.forEach((item:any) => {
      if(item.valueB <= interest && interest <= item.valueE){
        txt = item.langT;
      }
    });

    return txt;
  }
}